import React, { useEffect, useState } from 'react';
import invertColorsGrey from '../../assets/invertColorsGrey.svg';
import invertColorsContraste from '../../assets/invertColorsContraste.svg';
import { useGlobal } from '../../contexts/Global/context';

import * as S from './styles';

function AccessibilityBar() {
    const proportionFont = 0.1;
    const { contrastTheme, setContrastTheme } = useGlobal();

    const [dataAccessibility, setDataAccessibility] = useState({
        fontSize: 1,
    });

    function handleFontProportionPlus() {
        if (dataAccessibility.fontSize < 1.5) {
            setDataAccessibility({
                ...dataAccessibility,
                fontSize: dataAccessibility.fontSize + proportionFont,
            });
        }
    }

    function handleFontProportionMinus() {
        if (dataAccessibility.fontSize > 1) {
            setDataAccessibility({
                ...dataAccessibility,
                fontSize: dataAccessibility.fontSize - proportionFont,
            });
        }
    }

    function changeContrast() {
        setContrastTheme(!contrastTheme);

        const html = document.querySelector('html');
        html.classList.toggle('contraste');
    }

    useEffect(() => {
        document.querySelector('html').style.fontSize = `${dataAccessibility.fontSize}px`;
    }, [dataAccessibility]);

    return (
        <S.AccessibilityContainer>
            <S.AlignIcons>
                <S.AlignConstrastBtn onClick={() => changeContrast()}>
                    <img src={contrastTheme ? invertColorsContraste : invertColorsGrey} alt="Icone Contraste" />
                </S.AlignConstrastBtn>

                <S.LineSeparator />
                <S.AcessibilityFont id="plus" onClick={() => handleFontProportionPlus()}>
                    A+
                </S.AcessibilityFont>
                <S.LineSeparator />
                <S.AcessibilityFont id="minus" onClick={() => handleFontProportionMinus()}>
                    A-
                </S.AcessibilityFont>
            </S.AlignIcons>
        </S.AccessibilityContainer>
    );
}

export default AccessibilityBar;
